import React, { FC } from 'react';

import './ToggleButton.scss';

interface Props {
  label?: string;
  isChecked: boolean;
  onClick: () => void;
  inverted?: boolean;
}

const ToggleButton: FC<Props> = ({ label, isChecked, onClick, inverted }) => {
  return (
    <div className='toggle-button-container' onClick={onClick}>
      {inverted ?
        <>
          <p className='toggle-button-label'>{label}</p>
          <label className='toggle-button-switch'>
            <input type='checkbox' checked={isChecked} readOnly />
            <span className='toggle-button-slider' />
          </label>
        </> : <>
          <label className='toggle-button-switch'>
            <input type='checkbox' checked={isChecked} readOnly />
            <span className='toggle-button-slider' />
          </label>
          <p className='toggle-button-label'>{label}</p>
        </>
      }
    </div>
  );
};

export default ToggleButton;
